<template>
  <div class="row no-gutters">
    <div class="col-12 d-flex justify-content-center f-bold s-14">
      Draw your signature inside the field
    </div>
    <div class="col-12 d-flex justify-content-center" :key="drawArea">
      <VueSignaturePad id="signature"
                       width="100%"
                       height="150px"
                       :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
                       class="signature mt-2"
                       ref="signaturePad" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Draw',
  data() {
    return {
      image: false,
      drawArea: this.produceKey(),
    };
  },
  methods: {
    save() {
      const { signaturePad } = this.$refs;
      if (!signaturePad.isEmpty()) {
        const { data } = signaturePad.saveSignature();
        this.image = data;
      } else {
        this.warningMessage('You must draw signature to save.');
      }
    },
    clear() {
      this.image = false;
      this.drawArea = this.produceKey();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .signature {
canvas {
  background-color: #fff;
  border: 1px solid #d4d4d4;
}
}
</style>
